import Vue from 'vue'
import Vuex from 'vuex'
import admin_filters from './modules/admin_filters'
import common from './modules/common'
import offline from './modules/offline'
import params from './modules/params'
import courses from './modules/courses'
import libraries from './modules/libraries'
import trails from './modules/trails'
import registration_lists from './modules/registration_lists'
import site_lists from './modules/site_lists'
import users from './modules/users'
import webcasts from './modules/webcasts'
import welcome_banner from './modules/welcome_banner'
import podcasts from './modules/podcasts'
import presential from './modules/presential'
import datatable from './modules/datatable'
import datatable_columns from './modules/datatable_columns'
import live_classes from './modules/live_classes'
import redirect from './modules/redirect'
// import VuexPersistence from 'vuex-persist'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'

const ls = new SecureLS({ isCompression: true })
const dataState = createPersistedState({
	key: `${process.env.PROJECT_FOLDER}-v3`,
	storage: {
		getItem: (key) => {
			try {
				const value = ls.get(key)
				return typeof value === 'undefined' ? null : value
			} catch (e) {
				return null
			}
		},
		setItem: (key, value) => ls.set(key, value),
		removeItem: (key) => ls.remove(key),
	},
	paths: [
		// 'admin_filters',
		'common',
		// 'registration_lists',
		// 'site_lists',
		'params',
		// 'welcome_banner',
		// 'datatable',
		// 'datatable_columns',
	],
})

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		admin_filters,
		common,
		offline,
		params,
		courses,
		libraries,
		trails,
		registration_lists,
		site_lists,
		users,
		webcasts,
		welcome_banner,
		podcasts,
		presential,
		datatable,
		datatable_columns,
		live_classes,
		redirect,
	},
	// plugins: [vuexLocal.plugin]
	plugins: [dataState],
})
